import React from 'react';
import './ThemeToggle.css';

import { useTheme } from '../../context/ThemeContext';

interface ThemeToggleProps {}

export const ThemeToggle = ({ ...props }: ThemeToggleProps) => {
	const { activeTheme, setActiveTheme, inactiveTheme } = useTheme();
	return (
		<>
			<button
				className="theme-toggle-button"
				onClick={() => setActiveTheme(inactiveTheme)}
				aria-label={`Change to ${inactiveTheme} mode`}
				title={`Change to ${inactiveTheme} mode`}
			>
				<span
					className="theme-toggle-thumb"
					style={{
						transform:
							activeTheme === 'dark' ? 'translate3d(calc(var(--toggle-width) - var(--toggle-height)), 0, 0)' : 'none',
					}}
				></span>
				<span aria-hidden={true}>
					<svg width="20" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M13.3685 0.581515C10.5784 1.73608 8.61542 4.48496 8.61542 7.69231C8.61542 11.9407 12.0594 15.3846 16.3077 15.3846C17.1243 15.3846 17.9112 15.2574 18.6496 15.0216C16.9175 17.9987 13.6925 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C11.1819 0 12.316 0.205049 13.3685 0.581515Z"
							fill="#FAFAFA"
						/>
					</svg>
				</span>
				<span aria-hidden={true}>
					<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M9.38431 0.480051C9.59169 -0.160018 10.4947 -0.160017 10.7021 0.480052L12.48 5.96733C12.5727 6.25358 12.8387 6.44738 13.1388 6.44738H18.8923C19.5634 6.44738 19.8424 7.30859 19.2995 7.70417L14.6448 11.0955C14.402 11.2724 14.3004 11.586 14.3932 11.8722L16.1711 17.3595C16.3785 17.9996 15.6479 18.5318 15.105 18.1362L10.4504 14.7449C10.2076 14.568 9.87879 14.568 9.63598 14.7449L4.98136 18.1362C4.43842 18.5318 3.7079 17.9996 3.91528 17.3595L5.69318 11.8722C5.78593 11.586 5.68433 11.2724 5.44152 11.0955L0.786902 7.70417C0.24396 7.30858 0.522997 6.44738 1.19411 6.44738H6.94753C7.24766 6.44738 7.51366 6.25358 7.6064 5.96733L9.38431 0.480051Z"
							fill="#FFCA04"
						/>
						<path
							d="M14.2319 1.42853C14.7306 0.978198 15.5126 1.43096 15.3731 2.08926L14.1769 7.73285C14.1145 8.02725 14.2482 8.32846 14.5081 8.47895L19.4907 11.3638C20.0719 11.7003 19.8842 12.586 19.2167 12.6564L13.4948 13.2595C13.1963 13.2909 12.952 13.5116 12.8896 13.806L11.6934 19.4495C11.5539 20.1078 10.6558 20.2025 10.3829 19.5877L8.04275 14.3168C7.92068 14.0419 7.63593 13.877 7.33745 13.9085L1.61554 14.5116C0.948108 14.5819 0.580835 13.7547 1.07957 13.3043L5.35519 9.44367C5.57823 9.24228 5.64659 8.91977 5.52452 8.64481L3.18439 3.37396C2.91143 2.75913 3.58247 2.15322 4.16367 2.48972L9.14628 5.37456C9.4062 5.52505 9.73319 5.49058 9.95623 5.28919L14.2319 1.42853Z"
							fill="#FFCA04"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M10.1688 14.5695C12.7291 14.5695 14.8046 12.494 14.8046 9.93377C14.8046 7.37351 12.7291 5.298 10.1688 5.298C7.60858 5.298 5.53308 7.37351 5.53308 9.93377C5.53308 12.494 7.60858 14.5695 10.1688 14.5695ZM10.1689 13.9073C12.3634 13.9073 14.1424 12.1283 14.1424 9.93377C14.1424 7.73926 12.3634 5.96026 10.1689 5.96026C7.9744 5.96026 6.1954 7.73926 6.1954 9.93377C6.1954 12.1283 7.9744 13.9073 10.1689 13.9073Z"
							fill="#2F2F3A"
						/>
					</svg>
				</span>
			</button>
		</>
	);
};

export default ThemeToggle;
